import { Injectable } from '@angular/core';
import { Resident } from '../../../shared/models/resident.model';
import { ShopSelectionStore } from '../../state/shop-selection.store';
import { requiresPartnerAccountForBilling } from '../../partners/partner-registry';

@Injectable({
  providedIn: 'root',
})
export class PartnerPaymentGuardService {
  constructor(private shopSelectionStore: ShopSelectionStore) {}

  hasNoValidPaymentMethod(resident: Resident): boolean {
    return (
      this.hasNoPartnerPaymentMethod(resident) ||
      this.hasNoMynevaPaymentMethod(resident)
    );
  }

  private hasNoPartnerPaymentMethod(resident: Resident): boolean {
    if (!requiresPartnerAccountForBilling(resident?.partnerId)) {
      return false;
    }

    if (this.shopSelectionStore.snapshot.customer?.ordersWithoutSepaAllowed) {
      return false;
    }

    return !!(
      resident?.partnerResidentId &&
      !resident?.partnerAccountId &&
      resident?.hasIBAN === 0
    );
  }

  private hasNoMynevaPaymentMethod(resident: Resident): boolean {
    return !!(resident?.isMyNeva && !resident?.canOrderAsMyNeva());
  }
}
